import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { cutStringByWords } from "vig-ui-library/src/utils/string";

export type AssemblyDescriptionProps = {
    description: string;
    maxChars?: number;
}

export const AssemblyDescription = (props: AssemblyDescriptionProps) => {
    const { description } = props;

    const maxChars = props.maxChars ?? 500;

    const [isExpanded, setIsExpanded] = useState(false);

    return <Box>
        <Typography variant="body1">Popis</Typography>

        <Typography variant="subtitle1" sx={{ whiteSpace: "pre-line" }}>
            {isExpanded && description}
            {!isExpanded && cutStringByWords(description, maxChars)}
        </Typography>

        {description.length > maxChars && (
            <Button variant="text" size="small" onClick={() => setIsExpanded((prev) => !prev)}>
                {isExpanded ? "Zobraziť menej" : "Zobraziť viac"}
            </Button>
        )}
    </Box>
}